import { colors, darkColors } from "./colors";
import { space } from "./space";
import { fonts, fontSizes, fontWeights } from "./typography";

var pxToRem = function pxToRem(px) {
  return Number(px) / 16 + "rem";
};

export var theme = {
  colors: colors,
  dark: darkColors,
  space: space,
  sizes: space,
  fonts: fonts,
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  colorStyles: {
    clear: {
      color: "var(--colors-primary)",
      backgroundColor: "var(--colors-clear)"
    },
    base: {
      color: "var(--colors-primary)",
      backgroundColor: "var(--colors-base)"
    },
    baseLighter: {
      color: "var(--colors-primary)",
      backgroundColor: "var(--colors-baseLighter)"
    },
    primary: {
      color: "var(--colors-secondary)",
      backgroundColor: "var(--colors-primary)"
    },
    secondary: {
      color: "var(--colors-primary)",
      backgroundColor: "var(--colors-secondary)"
    },
    loading: {
      color: "var(--colors-primary)",
      background: "var(--colors-loading)"
    },
    shade05: {
      color: "var(--colors-primary)",
      backgroundColor: "var(--colors-shade05)"
    },
    shade10: {
      color: "var(--colors-primary)",
      backgroundColor: "var(--colors-shade10)"
    },
    shade20: {
      color: "var(--colors-primary)",
      backgroundColor: "var(--colors-shade20)"
    },
    shade40: {
      color: "var(--colors-primary)",
      backgroundColor: "var(--colors-shade40)"
    },
    shade60: {
      color: "var(--colors-primary)",
      backgroundColor: "var(--colors-shade60)"
    },
    shade80: {
      color: "var(--colors-primary)",
      backgroundColor: "var(--colors-shade80)"
    },
    confirm: {
      color: colors.secondary,
      backgroundColor: colors.confirm
    },
    inform: {
      color: colors.secondary,
      backgroundColor: colors.inform
    },
    warn: {
      color: colors.primary,
      backgroundColor: colors.warn
    },
    stop: {
      color: colors.secondary,
      backgroundColor: colors.stop
    },
    brand1: {
      color: colors.primary,
      backgroundColor: colors.brand1
    },
    brand2: {
      color: colors.secondary,
      backgroundColor: colors.brand2
    },
    brand3: {
      color: colors.secondary,
      backgroundColor: colors.brand3
    },
    brand4: {
      color: colors.primary,
      backgroundColor: colors.brand4
    },
    brand5: {
      color: colors.primary,
      backgroundColor: colors.brand5
    }
  },
  buttons: {
    primary: {
      color: "var(--colors-secondary)",
      backgroundColor: "var(--colors-primary)",
      borderColor: "var(--colors-primary)"
    },
    secondary: {
      color: "var(--colors-primary)",
      backgroundColor: "var(--colors-clear)",
      borderColor: "var(--colors-primary)"
    },
    tertiary: {
      color: "var(--colors-primary)",
      backgroundColor: "var(--colors-clear)",
      borderColor: "var(--colors-clear)"
    }
  },
  textStyles: {
    ts1: {
      fontSize: pxToRem(fontSizes.ts1),
      lineHeight: 1.5,
      letterSpacing: "0px"
    },
    ts1p5: {
      fontSize: pxToRem(fontSizes.ts1p5),
      lineHeight: 1.5,
      letterSpacing: "0.2px"
    },
    ts2: {
      fontSize: pxToRem(fontSizes.ts2),
      lineHeight: 1.33,
      letterSpacing: "0.2px"
    },
    ts2p5: {
      fontSize: pxToRem(fontSizes.ts2p5),
      lineHeight: 1.3,
      letterSpacing: "0.2px"
    },
    ts3: {
      fontSize: pxToRem(fontSizes.ts3),
      lineHeight: 1.31,
      letterSpacing: "0.1px"
    },
    ts3p5: {
      fontSize: pxToRem(fontSizes.ts3p5),
      lineHeight: 1.31,
      letterSpacing: "0.1px"
    },
    ts4: {
      fontSize: pxToRem(fontSizes.ts4),
      lineHeight: 1.2,
      letterSpacing: "-0.2px"
    },
    ts4p5: {
      fontSize: pxToRem(fontSizes.ts4p5),
      lineHeight: 1.2,
      letterSpacing: "-0.2px"
    },
    ts5: {
      fontSize: pxToRem(fontSizes.ts5),
      lineHeight: 1.16,
      letterSpacing: "-1.5px"
    },
    ts6: {
      fontSize: pxToRem(fontSizes.ts6),
      lineHeight: 1.01,
      letterSpacing: "-4px"
    },
    ts7: {
      fontSize: pxToRem(fontSizes.ts7),
      lineHeight: 1,
      letterSpacing: "7px"
    },
    ts8: {
      fontSize: pxToRem(fontSizes.ts8),
      lineHeight: 1,
      letterSpacing: "2px"
    },
    bodyCopy: {
      fontSize: pxToRem(fontSizes.bodyCopy),
      lineHeight: 1.5
    },
    caption: {
      fontSize: pxToRem(fontSizes.caption),
      lineHeight: 1.4
    }
  },
  grid: {
    columns: 27,
    maxWidth: 1440
  }
};